import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ViewChild,
} from '@angular/core';
import { GetRequestErrors, RequestsClient } from 'shared';
import { firstValueFrom, Subject } from 'rxjs';
import { NgrxBusy, withBusy } from 'ngrx-busy';
import * as Highcharts from 'highcharts';
import { groupBy } from 'extensions/array';
import moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import {DeviceErrorsDetailComponent} from "./device-errors-detail.component";

@Component({
  selector: 'app-device-errors',
  templateUrl: './device-errors.component.html',
  styleUrls: ['./device-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DeviceErrorsComponent {
  linesHighcharts: typeof Highcharts = Highcharts;

  // linesChartOptions: Highcharts.Options = {
  linesChartOptions: any = {
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    // subtitle: {
    //     text: 'Source: <a href="https://worldpopulationreview.com/world-cities" target="_blank">World Population Review</a>'
    // },
    xAxis: {
      type: 'category',
      labels: {
        autoRotation: [-45, -90],
        style: {
          fontSize: '13px',
          fontFamily: 'Verdana, sans-serif',
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      // pointFormat: 'Population in 2021: <b>{point.y:.1f} millions</b>'
    },
    series: [
      {
        name: 'Errors',
        // colors: [
        //     '#9b20d9', '#9215ac', '#861ec9', '#7a17e6', '#7010f9', '#691af3',
        //     '#6225ed', '#5b30e7', '#533be1', '#4c46db', '#4551d5', '#3e5ccf',
        //     '#3667c9', '#2f72c3', '#277dbd', '#1f88b7', '#1693b1', '#0a9eaa',
        //     '#03c69b',  '#00f194'
        // ],
        // colorByPoint: true,
        groupPadding: 0,
        cursor: 'pointer',
        data: [],
        events: {
          click: (event: any) => this.details(event.point.name, event)
          // click: function (event: any) {
          //   // console.log(this);
          //   console.log(event.point.name);
          //   // alert(
          //   //     this.name + ' clicked\n' +
          //   //     'Alt: ' + event.altKey + '\n' +
          //   //     'Control: ' + event.ctrlKey + '\n' +
          //   //     'Meta: ' + event.metaKey + '\n' +
          //   //     'Shift: ' + event.shiftKey
          //   // );
          // },
        },
        dataLabels: {
          enabled: true,
          rotation: -90,
          color: '#FFFFFF',
          inside: true,
          verticalAlign: 'top',
          // format: '{point.y:.1f}', // one decimal
          y: 10, // 10 pixels down from the top
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      },
    ],
  };

  @ViewChild(NgrxBusy, { static: true }) busy: NgrxBusy;

  private readonly unsubscribe$ = new Subject();
  isDataLoaded = false;
  // stats$: Observable<Stat[]>;

  constructor(
    private requestsClient: RequestsClient,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit(): Promise<any> {
    let errors = await firstValueFrom(
      this.requestsClient
        .getRequestErrors(new GetRequestErrors())
        .pipe(withBusy(() => this.busy))
    );

    let grouped = groupBy(errors, (error) => error.timestamp.format('MMM DD'));

    let result = [];
    for (let i = -30; i <= 0; i++) {
      let date = moment().add(i, 'days').format('MMM DD');
      result.push([date, 0]);
    }

    grouped.forEach((values, key, _) => {
      var row = result.find((r) => r[0] == key);
      if (!!row) row[1] = values.length;
      if (!!row) row[2] = values;
    });

    this.linesChartOptions.series[0].data = result;
    this.cdr.detectChanges();
    this.isDataLoaded = true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  details(key: string, event: any): void {
    this.dialog.open(DeviceErrorsDetailComponent, {data: this.linesChartOptions.series[0].data.find(d => d[0] == key)[2]});
  }
}
